/**
 * Security utility functions for frontend
 */

/**
 * Sanitize error message to prevent XSS
 * Removes HTML tags and limits length
 */
export const sanitizeErrorMessage = (error) => {
  if (!error) return 'An error occurred';
  
  if (typeof error !== 'string') {
    return 'An error occurred';
  }
  
  // Remove HTML tags
  let sanitized = error.replace(/<[^>]*>/g, '');
  
  // Limit length to prevent UI issues
  if (sanitized.length > 200) {
    sanitized = sanitized.substring(0, 200) + '...';
  }
  
  return sanitized;
};

/**
 * Sanitize filename to prevent XSS and path traversal
 */
export const sanitizeFilename = (filename) => {
  if (!filename) return 'file';
  
  // Remove dangerous characters
  return filename.replace(/[<>:"/\\|?*\x00-\x1f]/g, '');
};

/**
 * Validate input size (client-side)
 */
export const validateInputSize = (input, maxSizeMB = 10) => {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  const inputSize = new Blob([input]).size;
  
  if (inputSize > maxSizeBytes) {
    return {
      valid: false,
      error: `Input size exceeds maximum limit of ${maxSizeMB}MB`
    };
  }
  
  return { valid: true };
};

/**
 * Validate file size (client-side)
 */
export const validateFileSize = (file, maxSizeMB = 50) => {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  
  if (file.size > maxSizeBytes) {
    return {
      valid: false,
      error: `File size exceeds maximum limit of ${maxSizeMB}MB`
    };
  }
  
  return { valid: true };
};

/**
 * Sanitize user input (basic)
 */
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  
  // Remove null bytes and control characters
  return input.replace(/[\x00-\x1f\x7f]/g, '');
};

